export const EXISTING_PARTIAL_REQUEST = 40224;
export const EXISTING_INSERTED_REQUEST = 40225;
